<template>
  <div class="align-items-center justify-content-center tutorial-popup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="tutorial-wrapper">

          <div class="tutorial-window">
            <div class="header"></div>
            <div class="content">
              <TutorialPage
                  v-for="page in pages"
                  :key="page.id"
                  v-show="currentPageId === page.id"
                  :title="page.title"
                  :body="page.body"
                  :image="page.image"
                  :isFirstPage="page.id === 0"
                  :isLastPage="page.id === pages.length-1"
                  :buddy="buddy"
                  v-on:backClicked="backClicked()"
                  v-on:forwardClicked="forwardClicked()"
              ></TutorialPage>
              <div class="pips">
                <button class="pip btn" v-for="page in pages"
                        :key="page.id"
                        :class="currentPageId === page.id? 'large' : '' "
                        @click="pipClicked(page.id)"
                ></button>
              </div>

            </div>
            <div class="footer"></div>
          </div>

          <div class="button-row">

            <WhiteOutlineButton :buttonText="'Vorige'" :stretch-to-fill="false"
                                v-on:clicked="backToVideoClicked"></WhiteOutlineButton>

            <WhiteOutlineButton :buttonText="'Volgende'" :stretch-to-fill="false"
                                v-on:clicked="nextStepClicked"></WhiteOutlineButton>

          </div>

        </div>
      </transition>

    </div>
  </div>

</template>

<script>

  import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
  import TutorialPage from "@/components/StudentPlatform/Onboarding/TutorialPage";

  import tutorial1 from '@/assets/image/tutorial/introductie_01_beweegbuddies.png'
  import tutorial2 from '@/assets/image/tutorial/introductie_02_energie.png'
  import tutorial3 from '@/assets/image/tutorial/introductie_03_activiteiten.png'
  import tutorial4 from '@/assets/image/tutorial/introductie_04_gadgets.png'


  export default {
    name: "Tutorial",
    components: {WhiteOutlineButton, TutorialPage},
    props: {
      open: Boolean,
      buddy: Object,
    },
    data() {
      return {
        show: false,
        videoLoaded: false,

        currentPageId: 0,
        pages: [
          {
            id: 0,
            title: "UNIEKE BEWEEGBUDDY",
            body: "Beweegbuddies zijn uniek. Creeër met de klas je eigen beweegbuddy om samen energie te verzamelen.",
            image: tutorial1,
          },
          {
            id: 1,
            title: "ENERGIE VERZAMELEN",
            body: "Energie verzamel je door beweegopdrachten uit te voeren. De energie wordt onder de vorm van batterijtjes toegevoegd aan de teletijdsmachine om zo informatie door te sturen naar de toekomst.",
            image: tutorial2,
          },
          {
            id: 2,
            title: "VERSCHILLENDE SOORTEN BEWEGING",
            body: "Je kan batterijtjes verdienen door verschillende soorten beweegopdrachten te doen. Er zijn 4 categorieën: beweeg meer, slim, samen en tussendoor.",
            image: tutorial3,
          },
          {
            id: 3,
            title: "GADGETS",
            body: "Door veel activiteiten te doen kan je ook gadgets vrijspelen voor je eigen unieke beweegbuddy. Je kan hem verder personaliseren met een leuke uitrusting, cool hoofddeksel, …",
            image: tutorial4,
          },
        ]
      }
    },
    computed: {},
    mixins: [],
    methods: {

      closeClicked() {
        this.$emit("closeClicked");
      },

      onReady() {
        this.videoLoaded = true;
      },

      //#region carousel

      backClicked()
      {
        if (this.currentPageId <= 0)
        {
          //this.currentPageId = this.pages.length - 1;
        }
        else
        {
          this.currentPageId--;
        }
      },

      forwardClicked()
      {
        if (this.currentPageId >= this.pages.length - 1)
        {
          //this.currentPageId = 0;
        }
        else
        {
          this.currentPageId++;
        }
      },

      pipClicked(id) {
        this.currentPageId = id;
      },

      //#endregion

      backToVideoClicked()
      {
        if (this.currentPageId <= 0)
        {
          this.$emit("backToVideo");
        }
        else
        {
          this.currentPageId--;
        }
      },

      nextStepClicked()
      {
        if (this.currentPageId >= this.pages.length - 1)
        {
          this.$emit("nextStepClicked");
        }
        else
        {
          this.currentPageId++;
        }
      }


    },
    mounted() {
      let that = this;
      that.show = true;
    },
    created() {
    },
  }


</script>

<style lang="scss" scoped>

.tutorial-popup {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;

  .popup-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.tutorial-window {
  width: 50%;
  height: 50%;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    width: 600px;
    height: calc(600px * 0.086);
  }

  .content {
    //content is now fixed to allow the use of the user's buddy in tutorial images
    width: 600px;

    //width: 50vw;
    //min-height: calc(80vh - (50vw * 0.086 * 2));
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;

    width: 600px;
    height: calc(600px * 0.086);
  }

  .pips {
    display: flex;
    justify-content: center;
    align-items: center;

    .pip {
      width: 10px;
      height: 10px;
      padding: 0px;
      border-radius: 10px;
      background-color: white;
      margin: 5px;

      &.large {
        width: 15px;
        height: 15px;
      }
    }
  }
}


.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}


</style>